var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"party-logo-container",class:[
    _vm.circle ? 'party-logo-circle' : '',
    _vm.grayscale ? 'grayscale-img' : '',
    _vm.active ? 'active' : '',
    _vm.clickable
      ? 'cursor-pointer hover:shadow-lg transform-gpu transition-all duration-500 hover:scale-110 hover:ease-in-out'
      : '' ]},[_c('div',{staticClass:"party-logo-image"},[_c('img',{attrs:{"src":_vm.partyLogo(_vm.party)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }